/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import Footer from "./FooterContainer";

export default Footer;
